import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { environment } from '../../../../../../../environments/environment'
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MapsAPILoader, AgmMap } from '@agm/core';
import { GoogleMapsAPIWrapper } from '@agm/core/services';
declare var google: any;

interface Location {
    lat: number;
    lng: number;
    zoom: number;
}
import {InspectionStatusComponent} from '../../../../child-component/inspection-status/inspection-status.component';
@Component({
  selector: 'app-overview-property',
  templateUrl: './overview-property.component.html',
  styleUrls: ['./overview-property.component.scss'],
  // providers: [
  //   GoogleMapsAPIWrapper // <---
  // ]
})
export class OverviewPropertyComponent implements OnInit {
  @Input() job: any;
  @Input() jobData : any;
  // Administrators, or staff with "Inspections - Status" (see OverviewComponent.loadAccess).
  @Input() canChangeStatus = false;
  @Output () notify: EventEmitter<string> = new EventEmitter<string>();
  map_button_status:string = "Show Map";
  map_status:boolean = true;
  geocoder: any;
  constructor(
    public mapsApiLoader: MapsAPILoader,
      // private zone: NgZone,
      private wrapper: GoogleMapsAPIWrapper,
      config : NgbModalConfig,
        private modalService: NgbModal
   ) {
      this.mapsApiLoader = mapsApiLoader;
      // this.zone = zone;
      // this.wrapper = wrapper;
      config.backdrop = 'static';
        config.keyboard = false;
        this.mapsApiLoader.load().then(() => {
            this.geocoder = new google.maps.Geocoder();
        });
  }
    panorama: any;
    public location: Location = {
        lat: 51.678418,
        lng: 7.809007,
        zoom: 5
    };
  // no coordinates until the address is actually resolved - a hardcoded
  // fallback here is what used to show a San Diego house for every property
  loca: { lat: any, lng: any } = {
    lat: null,
    lng: null
  };
  streetViewService: any;
  userData;
  full_address = null;
  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem('user'));
    console.log(this.job);
  }
  
  ngOnChanges(){  
  }
     regenerateAddress() {
        this.full_address = this.job.property_address1 + "," + this.job.property_city + "," + this.job.property_state + "," + this.job.property_zip;
        this.findLocation(this.full_address);
    }

    findLocation(address) {
        if (!this.geocoder) {
            this.geocoder = new google.maps.Geocoder()
        }
        this.geocoder.geocode({
            'address': address
        }, (results, status) => {

            if (status == google.maps.GeocoderStatus.OK) {
                if (results[0].geometry.location) {
                    this.location.lat = results[0].geometry.location.lat();
                    this.location.lng = results[0].geometry.location.lng();
                    this.job.property_lat = this.location.lat;
                    this.job.property_long = this.location.lng;
                }
                this.loca = {
                    lat: this.job.property_lat,
                    lng: this.job.property_long
                }
                if (!this.map_status) {
                    this.streetMap();
                }
            } else {
                alert("Sorry, this search produced no results.");
            }
        })
    }


  hasLocation(): boolean {
    return this.loca != null
        && this.loca.lat != null && this.loca.lng != null
        && !isNaN(Number(this.loca.lat)) && !isNaN(Number(this.loca.lng));
  }

  streetMap() {
    if (!this.hasLocation()) {
        return;
    }
    const target = { lat: Number(this.loca.lat), lng: Number(this.loca.lng) };
    // the container is still [hidden] until change detection runs, and a
    // panorama built inside a 0x0 box comes up blank - build it after.
    setTimeout(() => {
        const container = document.getElementById('panozz');
        if (!container) {
            return;
        }
        const options = {
            position: target,
            pov: { heading: 0, pitch: 0 },
            visible: true,
            linksControl: false,
            panControl: false,
            enableCloseButton: false,
            fullscreenControl: false,
            zoomControl: false,
            motionTrackingControl: false,
            addressControl: false
        };
        if (this.panorama) {
            this.panorama.setOptions(options);
        } else {
            this.panorama = new google.maps.StreetViewPanorama(container, options);
        }
        google.maps.event.trigger(this.panorama, 'resize');
        this.faceProperty(target);
    });
  }

  // Street View drops the camera on the nearest road pointing due north.
  // Look up where that camera actually stands and turn it to the property.
  faceProperty(target) {
    if (!this.streetViewService) {
        this.streetViewService = new google.maps.StreetViewService();
    }
    this.streetViewService.getPanorama({ location: target, radius: 100 }, (data, status) => {
        if (status !== google.maps.StreetViewStatus.OK || !data || !data.location || !this.panorama) {
            return;
        }
        const camera = { lat: data.location.latLng.lat(), lng: data.location.latLng.lng() };
        this.panorama.setPano(data.location.pano);
        this.panorama.setPov({ heading: this.headingBetween(camera, target), pitch: 0 });
    });
  }

  // compass bearing from one point to another, in degrees clockwise from north
  headingBetween(from, to): number {
    const rad = Math.PI / 180;
    const lat1 = from.lat * rad;
    const lat2 = to.lat * rad;
    const dLng = (to.lng - from.lng) * rad;
    const y = Math.sin(dLng) * Math.cos(lat2);
    const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLng);
    return (Math.atan2(y, x) / rad + 360) % 360;
  }

  newStreetMap() {
        if (this.map_button_status === "Hide Map") {
            this.map_status = true;
            this.map_button_status = "Show Map";
            return;
        }

        this.map_status = false;
        this.map_button_status = "Hide Map";

        this.mapsApiLoader.load().then(() => {
            this.geocoder = new google.maps.Geocoder();
            this.regenerateAddress();
        });
    }
    openFormModal(id) {
        const modalRef = this.modalService.open(InspectionStatusComponent,{size:'lg'});
        modalRef.componentInstance.jobData = this.jobData;
        modalRef.result.then((result) => {
         
          this.jobData = result;
          this.notify.emit(this.jobData);
          // this.getTransactions();
        }).catch((error) => {
            console.log(error);
        });
    }
  // Colour key for the status pill (.im-job-status): the stage while Active, else the top status.
  get statusKey(): string {
    const top = (this.jobData && this.jobData.job_status_top || '').toLowerCase();
    const stage = (this.jobData && this.jobData.job_status || '').toLowerCase();
    return top === 'active' || top === '' ? (stage || 'active') : top;
  }

  onShowMap(){
    this.newStreetMap();
  }


}
